import { Button } from '@zorro/design-system/v2/Button';
import { CommentIcon } from '@zorro/shared/assets';
import { Group } from '@zorro/web/design-system';

type CommentsButtonProps = {
  commentsCount: number;
  onClick: () => void;
};

export const CommentsButton = ({
  onClick,
  commentsCount,
}: CommentsButtonProps) => {
  return (
    <Group>
      <Button
        onClick={onClick}
        variant="secondary"
        size="md"
        leftSection={<CommentIcon count={commentsCount} />}
      >
        Comments
      </Button>
    </Group>
  );
};

export const CommentsButtonIcon = ({
  onClick,
  commentsCount,
}: CommentsButtonProps) => {
  return (
    <Group>
      <Button onClick={onClick} variant="tertiary" size="md">
        <CommentIcon count={commentsCount} />
      </Button>
    </Group>
  );
};
